import { qs, qsa } from "../utils/dom"

export default function () {
  const header = qs('header')
  if (!header) return

  const level0Items = qsa('.menu-item-level-0', header)

  const addVisible = (el) => {
    if (el) el.classList.add('visible')
  }

  const removeVisible = (el) => {
    if (el) el.classList.remove('visible')
  }

  const clearAllLevel1 = () => {
    const level1Visible = header.querySelectorAll('.menu-item-level-1.visible, .submenu-level-1.visible')
    level1Visible.forEach(removeVisible)
  }

  const clearAllLevel0 = () => {
    const level0Visible = header.querySelectorAll('.menu-item-level-0.visible, .submenu-level-0.visible')
    level0Visible.forEach(removeVisible)
  }

  const updateHeaderVisibility = () => {
    const anyVisible = header.querySelector('.submenu-level-0.visible, .submenu-level-1.visible')
    if (anyVisible) {
      addVisible(header)
    } else {
      removeVisible(header)
    }
  }

  header.addEventListener('mouseleave', () => {
    clearAllLevel0()
    clearAllLevel1()
    removeVisible(header)
  })

  level0Items.forEach(level0 => {
    const submenu0 = level0.querySelector('.submenu-level-0')
    if (!submenu0) return

    const level1Items = submenu0.querySelectorAll('.menu-item-level-1')
    const firstLevel1 = level1Items[0]
    const firstSubmenu1 = firstLevel1 ? firstLevel1.querySelector('.submenu-level-1') : null

    level0.addEventListener('mouseenter', () => {
      clearAllLevel0()
      clearAllLevel1()

      addVisible(header)
      addVisible(level0)
      addVisible(submenu0)

      if (firstLevel1 && firstSubmenu1) {
        addVisible(firstLevel1)
        addVisible(firstSubmenu1)
      }

      level1Items.forEach(level1 => {
        const submenu1 = level1.querySelector('.submenu-level-1')
        if (!submenu1) return

        level1.addEventListener('mouseenter', () => {
          clearAllLevel1()
          addVisible(level1)
          addVisible(submenu1)
          updateHeaderVisibility()
        })
      })
    })

    level0.addEventListener('mouseleave', () => {
      clearAllLevel1()
      clearAllLevel0()
      updateHeaderVisibility()
    })
  })
}
